import WidgetSettings from './WidgetSettings.page';

export default WidgetSettings;